import { render, staticRenderFns } from "./FeedbackEditor.vue?vue&type=template&id=6ea0e5a2&scoped=true&"
import script from "./FeedbackEditor.vue?vue&type=script&lang=js&"
export * from "./FeedbackEditor.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackEditor.vue?vue&type=style&index=0&id=6ea0e5a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea0e5a2",
  null
  
)

export default component.exports